// extracted by mini-css-extract-plugin
module.exports = {"onOffBtn":"OnOffButton_onOffBtn__2T0Ex","onBtn":"OnOffButton_onBtn__2b5FA"};